// extracted by mini-css-extract-plugin
export default {"modal":"jDLCh","form":"_TRBO"};